export default "//cloud.imgsmail.ru/cloud.mail.ru/123509/img/build/emergencySwaImage.jpg";